<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="eight wide column">
            <Breadcrumb>
              <div class="active section">Sessões</div>
            </Breadcrumb>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <form
        :class="['ui small', { error: anyError }, 'form relative']"
        @submit.prevent="save"
      >
        <div class="ui padded grid">
          <div v-show="loading" class="ui active inverted dimmer">
            <div class="ui text loader">Carregando...</div>
          </div>
          <div class="row">
            <div class="six wide column">
              <div class="ui raised segment">
                <h4 class="ui dividing header">Configurações</h4>
                <ul>
                  <li v-for="(tab, index) in ordernedTabs" :key="index">
                    <router-link
                      :class="{ bold: currentTab == tab.name }"
                      :to="`/settings/${tab.name}`"
                    >
                      {{ tab.description }}
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
            <div class="ten wide column relative">
              <h4 v-show="currentTab == null" class="ui header">
                Selecione uma Configuração
              </h4>
              <NfseTab v-show="currentTab == 'nfse'" ref="tab-nfse" />
              <InvoiceTab v-show="currentTab == 'invoice'" ref="tab-invoice" />
              <ContractTab
                v-show="currentTab == 'contract'"
                ref="tab-contract"
              />
              <PaymentGatewayTab
                v-show="currentTab == 'payment_gateway'"
                ref="tab-payment_gateway"
              />
              <GeneralTab v-show="currentTab == 'general'" ref="tab-general" />
              <NotificationsTab
                v-show="currentTab == 'notifications'"
                ref="tab-notifications"
              />
            </div>
          </div>
          <!-- row -->
          <div class="row">
            <div class="sixteen wide right aligned column">
              <div class="ui divider"></div>
              <div class="field">
                <button
                  @click="save"
                  type="button"
                  name="save"
                  class="ui submit blue button"
                >
                  <i class="save icon"></i>Salvar Configurações
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- grid -->
      </form>
    </template>
  </PageLayout>
</template>

<script>
import Api from '@/resources/Api';
import Breadcrumb from '@/components/breadcrumb';
import PageLayout from '@/layouts/page_layout';
import NfseTab from './nfse_tab';
import InvoiceTab from './invoice_tab';
import ContractTab from './contract_tab';
import PaymentGatewayTab from './payment_gateway_tab';
import GeneralTab from './general_tab';
import NotificationsTab from './notifications_tab';

export default {
  name: 'users',
  components: {
    Breadcrumb,
    PageLayout,
    NfseTab,
    InvoiceTab,
    ContractTab,
    PaymentGatewayTab,
    GeneralTab,
    NotificationsTab
  },

  // provide() {
  //   // use function syntax so that we can access `this`
  //   return {
  //     loaded: this.loaded
  //   };
  // },

  data() {
    return {
      loading: false,
      currentTab: null,
      errors: [],
      settings: [],
      loaded: false,
      tabs: [
        {
          name: 'general',
          description: 'Gerais'
        },
        {
          name: 'nfse',
          description: 'Emissão de NFSe'
        },
        {
          name: 'invoice',
          description: 'Emissão de Parcelas'
        },
        {
          name: 'contract',
          description: 'Contrato'
        },
        {
          name: 'charge',
          description: 'Cobrança'
        },
        {
          name: 'notifications',
          description: 'Notificações'
        },
        {
          name: 'payment_gateway',
          description: 'Gateway de Pagamento'
        }
      ]
    };
  },

  computed: {
    ordernedTabs() {
      return _.orderBy(this.tabs, [tab => tab.description], ['asc']);
    },

    anyError() {
      return !_.isEmpty(this.errors);
    }
  },

  mounted() {
    this.loadSettings();
  },

  watch: {
    $route() {
      this.setCurrentTab();
    }
  },

  methods: {
    setCurrentTab() {
      this.currentTab = this.$route.params.tab;
      const $tab = this.$refs[`tab-${this.currentTab}`];
      if (!_.isEmpty($tab)) {
        $tab.setForm(this.settings);
      }
    },

    loadSettings() {
      this.loading = true;
      Api.settings
        .search({})
        .then(response => {
          this.settings = response.data.settings;
          this.setCurrentTab();
        })
        .catch(error => {
          this.$toast.show('Erro ao buscar configurações', 'error');
          throw error;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    save() {
      const keys = this.$refs[`tab-${this.currentTab}`].getSettings();
      this.loading = true;
      Api.settings
        .save({ keys: keys })
        .then(() => {
          this.$toast.show('Configurações salvas com sucesso', 'success');
        })
        .catch(error => {
          this.$toast.show('Erro ao salvar configurações', 'error');
          throw error;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="css" scoped>
/* li.father {
    padding-bottom: 1rem;
  } */

/* li{margin-bottom: 5px} */
</style>
